<div class="chat-message-input">
	<div class="input-container">
		<textarea md-form-input [formControl]="messageControl" placeholder="Type your message..." rows="1" (keydown)="onKeyDown($event)"></textarea>
		<div class="input-actions">
			<!-- <button type="button" md-button class="attach-button" title="Attach file (coming soon)" [disabled]="true">
				<md-icon [icon]="'untitled-ui/editor/attachment-01'"></md-icon>
			</button> -->
			<div></div>
			<button type="button" md-button-brand class="send-button" (click)="sendMessage()" [disabled]="!messageControl.value?.trim() || isSending()">
				<md-icon [icon]="'untitled-ui/arrows/arrow-up'"></md-icon>
				Send
			</button>
		</div>
	</div>
</div>
